import React from 'react';
import ConfidenceFlag from '../../../../components/common/confidenceFlag.component';
import { ClosedStatusChip } from '@workboard/ui-okr';
import { metricdetailConstants } from '../../../constants/okrPopUp.constants';
import { useTranslation } from 'react-i18next';

const GraphHeader = ({ metric }) => {
    const { t } = useTranslation()
    const metricType = metric.confidence.confidence;
    const confType = ['Low confidence', 'Medium confidence', 'High confidence'];
    const showClosedLook = !!window.wbConfig?.isCloseKeyResultEnabled
        && Number(metric.status) === metricdetailConstants.METRIC_CLOSED;

    return (
        <div className="goal-chart-header">
            <div className="goal-chart-headline">
                <div
                    className={`goal-chart-title${showClosedLook ? ' goal-chart-title-closed' : ''}`}
                    role="heading"
                    aria-level={2}
                    data-source={metric.source}
                    data-testid="goal-chart-title"
                >
                    {metric.name}
                </div>
                {showClosedLook && <ClosedStatusChip size="medium" />}
            </div>
            <div className="goal-chart-line" />
            <div className="goal-target-section">
                <div className="as-of-text">
                    <span style={{ paddingRight: '10px' }} dangerouslySetInnerHTML={{ __html: metric.as_of_now }} />
                </div>
                <div className="goal-target-text-top" data-testid="goal-target-text-top">
                    <span className="wb-goal-achieve-text" data-testid="wb-goal-achieve-text" style={{ color: metric.metric_progress_color }}>
                        {metric.achieveTarget}
                    </span>
                    {metric.targetDisplay && <span className="wb-goal-target-text"> {t('of')} {metric.totalTarget}</span> }
                    {
                        metric.display_kr_confidence
                            && metric.confidence
                            && (metric.confidence.confidence != undefined && metric.confidence.confidence != 0)
                            && (
                                <span
                                    className="krDetailConfidenceWrapper"
                                    style={{ verticalAlign: 'bottom', display: 'inline-block', height: '18px' }}
                                >
                                    <ConfidenceFlag
                                        type={metric.confidence.confidence}
                                        cDate={metric.confidence.created_at_formatted}
                                        uName={metric.confidence.added_by_name}
                                        comment={metric.confidence.comment}
                                        id={metric.id}
                                        classProp="krRow"
                                        label={
                                            `${confType[metricType - 1] || ''} .&nbsp;
                                                As of ${metric.confidence.created_at_formatted}.&nbsp;
                                                ${metric.confidence.added_by_name}
                                                ${metric.confidence.comment}
                                            `
                                        }
                                    />
                                </span>
                            )
                    }
                </div>
            </div>
        </div>
    )
}

export default GraphHeader;
